import api from "./api";

let _scriptPromise = null;
function loadRazorpayScript() {
  if (_scriptPromise) return _scriptPromise;
  _scriptPromise = new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("Razorpay SDK failed to load"));
    document.body.appendChild(s);
  });
  return _scriptPromise;
}

/**
 * Book a video consultation (₹200 base or ₹399 premium).
 * @param {{name,email,phone,subject,description,preferred_staff_id?}} payload
 */
export async function bookVideoConsultation(payload) {
  const { data: order } = await api.post("/payments/video/order", {
    name: payload.name,
    email: payload.email,
    phone: payload.phone,
    preferred_staff_id: payload.preferred_staff_id || undefined,
  });

  if (order.mock) {
    // Simulate a checkout delay so UX feels real.
    await new Promise((r) => setTimeout(r, 900));
    const { data } = await api.post("/payments/video/verify", {
      order_id: order.order_id,
      request_data: payload,
    });
    return { ...data, mock: true };
  }

  // Real Razorpay flow
  await loadRazorpayScript();
  return new Promise((resolve, reject) => {
    const options = {
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      order_id: order.order_id,
      name: "UID Infotech",
      description: "Instant Expert Video Support — ₹200",
      handler: async (res) => {
        try {
          const { data } = await api.post("/payments/video/verify", {
            order_id: res.razorpay_order_id,
            payment_id: res.razorpay_payment_id,
            signature: res.razorpay_signature,
            request_data: payload,
          });
          resolve({ ...data, mock: false });
        } catch (e) {
          reject(e);
        }
      },
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
      prefill: {
        name: payload.name || "",
        email: payload.email || "",
        contact: payload.phone || "",
      },
      theme: { color: "#2563EB" },
    };
    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", (resp) => reject(new Error(resp?.error?.description || "Payment failed")));
    rzp.open();
  });
}

/**
 * Subscribe to UID Care monthly plan (₹999/mo).
 * Mirrors the video flow: mock-aware Razorpay.
 */
export async function subscribeUidCare() {
  const { data: order } = await api.post("/subscriptions/uid-care/order");

  if (order.mock) {
    await new Promise((r) => setTimeout(r, 900));
    const { data } = await api.post("/subscriptions/uid-care/verify", {
      order_id: order.order_id,
      payment_id: `pay_mock_${Math.random().toString(36).slice(2, 10)}`,
      signature: "mock-signature",
    });
    return { ...data, mock: true };
  }

  await loadRazorpayScript();
  return new Promise((resolve, reject) => {
    const options = {
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      order_id: order.order_id,
      name: "UID Infotech",
      description: "UID Care — Monthly Plan (₹999)",
      handler: async (res) => {
        try {
          const { data } = await api.post("/subscriptions/uid-care/verify", {
            order_id: res.razorpay_order_id,
            payment_id: res.razorpay_payment_id,
            signature: res.razorpay_signature,
          });
          resolve({ ...data, mock: false });
        } catch (e) { reject(e); }
      },
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
      prefill: { name: order.user_name || "", email: order.user_email || "" },
      theme: { color: "#10B981" },
    };
    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", (resp) => reject(new Error(resp?.error?.description || "Payment failed")));
    rzp.open();
  });
}
